// Module
var code = "<div>\n\n  <section class=\"heading\">\n    <div class=\"row no-gutter\">\n      <ng-include src=\"'/dashboard/nav.html'\"></ng-include>\n    </div>\n  </section>\n\n\n  <div class=\"row no-gutter\">\n    <supporting-documents-files current-user=\"currentUser\" on-success=\"onSuccess\" on-error=\"onError\" />\n  </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = '/dashboard/supporting_document_files.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;